import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";

import { FormContainer, FormRowView, WidgetContainer, WidgetView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, UITextInput } from "components/ui";

import "./styles.css";

export default function FastBalancesWidget(props) {
    const { data, ui, onEnableFastBalances, onMobileDeviceUpdate } = useStateManager();
    const mobileDevice = data.mobileDevice ?? {};
    const showOnlyPlaceholder = mobileDevice.isEnrolled;
    const placeholder = showOnlyPlaceholder ? mobileDevice.name : "";

    return (
        <WidgetContainer className="fast-balances-widget">
            <WidgetView text="Fast Balances">
                <FormContainer className="fast-balances-form">
                    <FormRowView text="Device Name (e.g. Mary's Phone)">
                        { !showOnlyPlaceholder && 
                        <UITextInput value={ mobileDevice.name } placeholder={ placeholder } dataPoint="Device_Name_Input" onBlur={ onMobileDeviceUpdate("name") } />
                        }
                        { showOnlyPlaceholder && 
                        <UITextInput placeholder={ placeholder } dataPoint="Device_Name_Input" disabled />
                        }
                        </FormRowView>
                    <FormButtonRow>
                        { !mobileDevice.isEnrolled &&
                        <PrimaryButton text="Enable Fast Balances" dataPoint="Enable_Fast_Balances_Button" onClick={ onEnableFastBalances } />
                        }
                        { mobileDevice.isEnrolled &&
                        <DisabledPrompt>
                            <PrimaryButton text="Disable Fast Balances" dataPoint="Disable_Fast_Balances_Button" />
                        </DisabledPrompt>
                        }
                    </FormButtonRow>
                </FormContainer>
            </WidgetView>
        </WidgetContainer>

    )
}
